// extracted by mini-css-extract-plugin
module.exports = {"tabs":"OfficeManagement_tabs__3oB4L"};